module.exports = __webpack_public_path__ + "static/media/99gal18.02bac7ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal18.jpg
// module id = 73
// module chunks = 0